import React from 'react'

const Cart = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
      <path
        d="M8.36719 18.5C9.2806 18.5001 10.0215 19.2466 10.0215 20.167C10.0213 21.0873 9.2805 21.8329 8.36719 21.833C7.45379 21.833 6.71307 21.0873 6.71289 20.167C6.71289 19.2465 7.45369 18.5 8.36719 18.5ZM18.291 18.5C19.2044 18.5001 19.9453 19.2466 19.9453 20.167C19.9451 21.0873 19.2043 21.8329 18.291 21.833C17.3776 21.833 16.6369 21.0873 16.6367 20.167C16.6367 19.2465 17.3775 18.5 18.291 18.5ZM4.18652 3.5C4.64137 3.50021 5.03769 3.81227 5.14844 4.25684L5.65039 6.26953H20.1621C21.4568 6.26958 22.3987 7.49588 22.085 8.75586L20.4727 15.2305C20.1403 16.5645 18.95 17.4999 17.585 17.5H8.72363C7.35983 17.5 6.16959 16.5678 5.83691 15.2324L3.96875 7.73535L1.81543 5.1416C1.56834 4.8438 1.51474 4.42887 1.67773 4.07715C1.84084 3.72535 2.19083 3.50009 2.57617 3.5H4.18652ZM7.76172 14.7451C7.87219 15.1886 8.2673 15.5 8.72363 15.5H17.585C18.0399 15.4999 18.4361 15.1878 18.5469 14.7432L20.1602 8.26953H6.14844L7.76172 14.7451Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Cart
